module.exports = __webpack_public_path__ + "img/HappyFace.8c881afa.svg";